<app-basic-select [options]="warehouseTransactionTypes" [(ngModel)]="localValue" [iconClass]="'toggles fw-semibold'" [title]="title" (ngModelChange)="onValueChange($event)"></app-basic-select>
